'use client';

import * as React from 'react';
import { TimeGridEvent } from "../event/time-grid-event/TimeGridEvent.mjs";

/**
 * Components internally overridable inside `DayTimeGrid`. The context is seeded with the
 * desktop renderers as its default value, so consumers always receive a usable renderer
 * without wrapping `DayTimeGrid` in a provider. The compact views (`CompactDayView`,
 * `CompactThreeDayView`, `CompactWeekView`) wrap `DayTimeGrid` with this provider to swap
 * in the touch-optimized variant.
 */

export const DayTimeGridInternalRenderersContext = /*#__PURE__*/React.createContext({
  timeGridEvent: TimeGridEvent
});
if (process.env.NODE_ENV !== "production") DayTimeGridInternalRenderersContext.displayName = "DayTimeGridInternalRenderersContext";
export function useDayTimeGridInternalRenderers() {
  return React.useContext(DayTimeGridInternalRenderersContext);
}